import { Link } from 'react-router-dom';
import MediaFigure from '../components/MediaFigure';
import aerialViewBeforeStarting from '../aerial-view-field-before-starting.png';
import initialPlansElevations from '../initial-plans-elevations.png';
import locationPlan from '../location-plan.png';
import planOfHouseLayout from '../plan-of-house-layout.png';
import siteFromAbove from '../site-from-above.png';
import visualisedFrontage from '../visualised-frontage.png';
import { R_A_ROWE_URL } from '../site';

function DevelopmentSitePage() {
  return (
    <main className="Page Page--subpage">
      <div className="Page-content">
        <h1 className="Page-title">Our first builds</h1>
        <p className="Page-intro">
          This is AnchorPark Homes&apos; first building site — two brand-new
          semi-detached houses in a peaceful Devon village, with planning and
          layout shaped to complement the local character. Further developments
          are planned across additional sites from 2028.
        </p>
        <p className="Page-intro">
          Below is an early artist&apos;s impression of the frontage, followed
          by plan views of the site. Elevational drawings and the house layout
          plan are shown together at the foot of the page.
        </p>

        <p className="Design-team">
          Our design team includes Lead Designer and Architect{' '}
          <strong>Gareth Short</strong> of{' '}
          <a href={R_A_ROWE_URL} target="_blank" rel="noopener noreferrer">
            R A Rowe
          </a>
          , the architectural practice based on the Cornwall–Devon border.
        </p>

        <div className="MediaGallery MediaGallery--frontage">
          <MediaFigure
            enhanced
            src={visualisedFrontage}
            alt="Artist's impression of the completed front elevation of the two semi-detached houses"
            caption="Visualised frontage — artist's impression"
          />
        </div>

        <div
          className="MediaGallery MediaGallery--compact MediaGallery--triple"
          role="group"
          aria-label="Site plan views"
        >
          <MediaFigure
            compact
            src={aerialViewBeforeStarting}
            alt="Aerial view of the development field before construction work began"
            caption="Before construction"
          />
          <MediaFigure
            compact
            src={locationPlan}
            alt="Location plan showing the development site in relation to surrounding roads and properties"
            caption="Location plan"
          />
          <MediaFigure
            compact
            src={siteFromAbove}
            alt="Aerial view of the development site from above"
            caption="Site from above"
          />
        </div>

        <div
          className="MediaGallery MediaGallery--pair"
          role="group"
          aria-label="Architectural plans"
        >
          <MediaFigure
            src={initialPlansElevations}
            alt="Initial architectural elevation drawings for the semi-detached houses"
            caption="Initial plans — elevational drawings"
          />
          <MediaFigure
            src={planOfHouseLayout}
            alt="Plan showing the internal layout of the semi-detached houses"
            caption="Plan of house layout"
          />
        </div>

        <div className="Page-actions">
          <Link to="/build-progress" className="Button">
            View build progress
          </Link>
          <Link to="/" className="Button Button--secondary">
            Back to home
          </Link>
        </div>
      </div>
    </main>
  );
}

export default DevelopmentSitePage;
